import { render, staticRenderFns } from "./InfoTextTitle.vue?vue&type=template&id=6ab8576d"
import script from "./InfoTextTitle.vue?vue&type=script&lang=js"
export * from "./InfoTextTitle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports